module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-28.5519cfa7.png";